export const RESE_FILE_UPLOAD_TYPES = {
  STORE: {
    id: 1,
    name: 'Store',
  },
  BMS: {
    id: 2,
    name: 'BMS',
  },
  ENERGY_METER: {
    id: 3,
    name: 'Energy Meter',
  },
  BMS_BRAND: {
    id: 4,
    name: 'Bms Brand',
  },
  USER: {
    id: 5,
    name: 'User',
  },
  DRIVER_CONFIGURATION: {
    id: 6,
    name: 'Driver Configuration',
  }
};